import React, { useState, useRef } from 'react'
import Navbar from './layout/Navbar'
import Footer from './layout/Footer'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import SentenciasPenales from './SentenciasPenales'
import SentenciasViolencia from './SentenciasViolencia'
import SentenciasAlimentos from './SentenciasAlimentos'
import CardOption from './CardOption'

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 600,
    textAlign: 'center',
    fontSize: 25,
    margin: '3em auto 1em'
  },
  resume: {
    margin: '0 auto 3em',
    textAlign: 'center'
  }
}))

function Page() {
  const classes = useStyles()
  const refContainer = useRef(null)
  const [map, setMap] = useState('')

  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

  const handleSelect = sentencia => {
    setMap(sentencia)
    scrollToRef(refContainer)
  }

  return (
    <>
      <Navbar />
      <div style={{ minHeight: '100vh' }}>
        <Container
          maxWidth="lg"
          style={{ margin: '2em auto 4em', maxWidth: 1080 }}
        >
          <h1 className={classes.title}>Mapa de vigilancia electoral</h1>
          <div>
            <p className={classes.resume}>
              Herramienta elaborada con la información que consignaron los
              candidatos en sus declaraciones juradas de hoja de vida.
            </p>
          </div>
          <div>
            <CardOption handleSelect={handleSelect} selected={map} />
          </div>
          <div ref={refContainer}>
            {map === 'penales' && <SentenciasPenales />}
            {map === 'violencia' && <SentenciasViolencia />}
            {map === 'alimentos' && <SentenciasAlimentos />}
          </div>
        </Container>
      </div>
      <Footer />
    </>
  )
}

export default Page
